module.exports = __webpack_public_path__ + "static/media/Island25.ebe7e51f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/elements/Island25.svg
// module id = 76
// module chunks = 0